import { getAuthToken } from '../../../config/supabase';
import { maybeSendPush, getNotificationChannel } from '../../../utils/notify';

export const getTimestamp = () => new Date().toISOString();

export const sendTelegramNotification = async (message, type = '', customChatId = '') => {
  // Fan out to Firebase push in parallel (opt-in via the notification-channel
  // setting; no-op on the default 'telegram'). Fire-and-forget.
  maybeSendPush(message, type);
  // If the user chose push ONLY, skip Telegram entirely.
  if (getNotificationChannel() === 'push') return;

  // Master switch: if Telegram notifications are globally disabled, send nothing.
  // (undefined/true → enabled, preserving behavior for existing users)
  try {
    const masterRaw = localStorage.getItem('appSettings');
    if (masterRaw && JSON.parse(masterRaw).telegramEnabled === false) return;
  } catch (_) {}

  // Check if this notification type is disabled by the user
  if (type) {
    const savedRaw = localStorage.getItem('appSettings');
    if (savedRaw) {
      try {
        const s = JSON.parse(savedRaw);
        if (s.telegramNotifications && s.telegramNotifications[type] === false) {
          return; // User disabled this type
        }
      } catch (_) {}
    }
  }

  let chatId = customChatId;
  if (!chatId) {
    const saved = localStorage.getItem('appSettings');
    if (saved) {
      try {
        const settings = JSON.parse(saved);
        chatId = settings.telegramChatId || '';
      } catch (_) {}
    }
  }
  if (!chatId) return; // token is held server-side; only chatId is needed here
  try {
    const authToken = await getAuthToken();
    await fetch('/api/telegram/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {})
      },
      body: JSON.stringify({ chatId, text: message })
    });
  } catch (err) {
    console.error('Telegram error:', err);
  }
};

export const formatDateFR = (isoDate) => {
  if (!isoDate || typeof isoDate !== 'string') return isoDate || '';
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(isoDate)) return isoDate;
  const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    return `${match[3]}/${match[2]}/${match[1]}`;
  }
  try {
    const d = new Date(isoDate);
    if (!isNaN(d.getTime())) {
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    }
  } catch {}
  return isoDate;
};

export const formatDateLongFR = (isoDate) => {
  if (!isoDate) return '';
  try {
    const d = new Date(isoDate);
    if (isNaN(d.getTime())) return formatDateFR(isoDate);
    return d.toLocaleDateString('fr-FR', { 
      day: '2-digit', month: '2-digit', year: 'numeric' 
    });
  } catch { return formatDateFR(isoDate); }
};
